var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6073_498195)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8584 9.78021L7.94679 14.7723V11.848C14.9018 11.848 20.5399 17.3795 20.5399 24.2029H16.9419L22.0303 29.195L27.1186 24.2029L24.1379 24.2029C24.1379 15.4299 16.8889 8.31805 7.94679 8.31805V4.78809L2.8584 9.78021Z",
    fill: "#14151C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96914 19.5609L0 9.78047L9.96914 0V6.44375C18.4126 7.35855 25.1168 13.9359 26.0493 22.2195L32 22.2195L22.0309 32L12.0617 22.2195H18.3257C17.5091 18.0824 14.1861 14.8223 9.96914 14.0211V19.5609ZM7.94746 11.8482C8.63564 11.8482 9.31093 11.9024 9.96914 12.0066C15.3048 12.8513 19.5181 16.9849 20.3791 22.2195C20.4853 22.8653 20.5405 23.5278 20.5405 24.203H16.9425L22.0309 29.195L27.1192 24.203H24.1385C24.1385 24.2011 24.1385 24.1993 24.1385 24.1974C24.1355 15.4271 16.8877 8.31833 7.94746 8.31833V4.78841L2.8591 9.78047L7.94746 14.7725V11.8482Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6073_498195",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6073_498195"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6073_498195",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotation);
export default __webpack_public_path__ + "static/media/rotation.161d987565a81d3625355b89fa94efff.svg";
export { ForwardRef as ReactComponent };